module.exports = fox._r("images/video-example.jpg", __webpack_public_path__ + "images/video-example.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/video-example.jpg
// module id = 1027
// module chunks = 4